<template>
    <button
        v-if="buttonType === 'button'"
        :type="type"
        class="common-button relative w-full max-w-fit rounded-lg text-center text-base font-semibold max-lg:px-3 max-lg:py-2 lg:px-12 lg:py-[10px] lg:text-sm"
        :class="[
            'whitespace-nowrap px-12 py-[10px] max-lg:text-xs lg:text-base',
            classes,
            {
                'border border-violet-900 bg-transparent text-violet-900':
                    isOutline,
                'bg-violet-900 text-white': !isOutline && !isDisabled,
                'bg-gray-200 text-gray-700': isDisabled,
            },
        ]"
        :disabled="loading || isDisabled"
        @click="action"
    >
        <slot></slot>
        <div
            v-if="loading"
            class="absolute inset-0 z-10 flex w-full justify-center rounded-lg bg-grey-500 bg-opacity-50 transition-opacity"
        >
            <img
                :src="`${
                    useRuntimeConfig().public.staticUrl
                }/assets/img/loader/spinner.svg`"
                alt="loading-spinner"
                srcset=""
            />
            <span class="sr-only">Loading...</span>
        </div>
    </button>
    <NuxtLink
        v-if="buttonType === 'link'"
        :to="localePath(link)"
        class="relative w-full max-w-fit rounded-lg px-4 py-2 text-base font-semibold text-center lg:py-[10px] lg:text-sm"
        :class="[
            classes,
            {
                'border border-violet-900 bg-transparent text-violet-900':
                    isOutline,
                'bg-violet-900 text-white': !isOutline,
            },
        ]"
        :data-outline="isOutline"
    >
        <slot></slot>
    </NuxtLink>
</template>
<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
    loading: {
        type: Boolean,
        default: false,
    },
    classes: {
        type: String,
        default: '',
    },
    isDisabled: {
        type: Boolean,
        default: false,
    },
    action: {
        type: Function,
        default: () => {},
    },
    link: {
        type: String,
        default: '',
    },
    buttonType: {
        type: String,
        default: 'button', // button, link
    },
    isOutline: {
        type: Boolean,
        default: false,
    },
})

const localePath = useLocalePath()
</script>
